import React from "react";
import StarRating from "./StarRating";

const Solution = () => {
  return (
    <div>
      Solution
      <StarRating />
    </div>
  );
};

export default Solution;
